import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { Grid } from 'web-ui-components/lib/layout/grids';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import { AccountPaymentTable } from 'web-ui-components/lib/finance/accounts';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import withContent from '../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from '../PaymentDetails/bacs/BacsPayment.content';
import { formatDate, formatLongDateTime } from '../../utils/dateUtils';
import { formatAccountDetails } from '../../utils/accountUtils';
import { verificationPropTypes } from '../../states/payments/propTypes';
import { formatAmount } from '../../utils/numberUtils';
import {
	showAccountDetails,
	showAmount,
	getFormattedReference,
	showHmrcReference,
	showTransactionCode,
} from '../../utils/paymentsUtils';
import { BACS_DEBIT_CODE } from '../../config';

export const ViewBacsPaymentDetailsForOtherUsers = ({ content, payment = {}, goBack }) => {
	const {
		title,
		fromLabel,
		toLabel,
		amountLabel,
		refLabel,
		createdByLabel,
		createdOnLabel,
		bacsTypeLabel,
		bacsCreditLabel,
		hmrcRefLabel,
		bacsIdLabel,
		submissionDateLabel,
		settlementDateLabel,
		totalAmountLabel,
		bacsDebitLabel,
		bacsDebitSettlementDateLabel,
		transactionCodeLabel,
		transactions,
		back,
	} = content;
	const {
		created_timestamp,
		total,
		created_by,
		account,
		bacs_id,
		submission_date,
		settlement_date,
		entries,
		bacsType,
	} = payment;

	const headerBacsCredit = [
		{ type: 'account', label: toLabel },
		{ type: 'currency', label: amountLabel },
		{ type: 'iban', label: refLabel },
		{ type: 'iban', label: hmrcRefLabel },
	];

	const headerBacsDebit = [
		{ type: 'account', label: fromLabel },
		{ type: 'currency', label: amountLabel },
		{ type: 'iban', label: refLabel },
		{ type: 'iban', label: transactionCodeLabel },
	];

	const getOthersDataForFileUpload = (payment) => {
		if (bacsType === BACS_DEBIT_CODE) {
			return payment.map((bacsPayment, index) => {
				const { account, amount, reference, transaction_code } = bacsPayment;
				return [
					showAccountDetails(account, index),
					showAmount(amount.value, index),
					getFormattedReference(reference, index),
					showTransactionCode(transaction_code, index),
				];
			});
		}
		return payment.map((bacsPayment, index) => {
			const { account, amount, reference, hmrc_reference } = bacsPayment;
			return [
				showAccountDetails(account, index),
				showAmount(amount.value, index),
				getFormattedReference(reference, index),
				showHmrcReference(hmrc_reference, index),
			];
		});
	};

	const rows = [].concat(...getOthersDataForFileUpload(entries));

	const otherUsersPaymentsData = [
		{ headerText: bacsTypeLabel, cellText: bacsType === 'BCR' ? bacsCreditLabel : bacsDebitLabel },
		{ headerText: bacsType === 'BCR' ? fromLabel : toLabel, cellText: formatAccountDetails(account) },
		{ headerText: bacsIdLabel, cellText: bacs_id },
		{ headerText: submissionDateLabel, cellText: formatDate(submission_date) },
		{
			headerText: bacsType === 'BCR' ? settlementDateLabel : bacsDebitSettlementDateLabel,
			cellText: formatDate(settlement_date),
		},
		{ headerText: transactions, cellText: entries.length },
		{ headerText: totalAmountLabel, cellText: formatAmount(total) },
		{ headerText: createdByLabel, cellText: created_by },
		{ ...(created_timestamp ? { headerText: createdOnLabel, cellText: formatLongDateTime(created_timestamp) } : []) },
	];

	return (
		<div>
			<SectionHeading>{title}</SectionHeading>
			<Grid.TwoThirds>
				<VerticalReviewTable data={otherUsersPaymentsData} />
			</Grid.TwoThirds>
			<AccountPaymentTable headerData={bacsType === 'BCR' ? headerBacsCredit : headerBacsDebit} tableData={rows} />
			<Button id="button-back" display="secondary" width="flush" onClick={goBack}>
				{back}
			</Button>
		</div>
	);
};

ViewBacsPaymentDetailsForOtherUsers.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payment: PropTypes.shape(verificationPropTypes),
	goBack: PropTypes.func,
};

const contentWrapper = withContent({ content: paymentDetailsContent });
export default connect()(contentWrapper(ViewBacsPaymentDetailsForOtherUsers));
export const ConnectWrapper = connect()(ViewBacsPaymentDetailsForOtherUsers);
